import { render, staticRenderFns } from "./allsort.vue?vue&type=template&id=2949bcc6&scoped=true&"
import script from "./allsort.vue?vue&type=script&lang=js&"
export * from "./allsort.vue?vue&type=script&lang=js&"
import style0 from "./allsort.vue?vue&type=style&index=0&id=2949bcc6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2949bcc6",
  null
  
)

export default component.exports